<template>
  <v-card flat>
    <v-card-title>
      <div v-if="tranMode === 'new'">
        <div class="headline">New Cover Type</div>
      </div>
      <div v-if="tranMode === 'query'">
        <div class="headline">View Cover Type</div>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader class="queryLabel">{{ labels.cvrType }}</v-subheader>
            <div class="queryValue">{{ getDesc(cvrType) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="tranMode === 'new'">
          <v-flex xs12>
            <v-autocomplete
              :items="busClsList"
              v-model="busClsCvrFrom.busCls"
              :label="labels.busCls"
              item-text="label"
              item-value="value"
              data-vv-name="busCls"
              :data-vv-as="labels.busCls"
              :error-messages="errors.collect('busCls')"
              v-validate="'required'"
            ></v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-if="tranMode === 'query'">
          <v-flex xs12>
            <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
            <div class="queryValue" v-for="item in filterBusClsList" :key="item.label">{{ item.label }}</div>
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ busClsCvrFrom.createdName }}</div>
          </v-flex>
          <v-flex xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(busClsCvrFrom.createdDate) }}</div>
          </v-flex>
          <v-flex xs6 v-if="tranMode === 'query'">
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ busClsCvrFrom.modifiedName }}</div>
          </v-flex>
          <v-flex xs6 v-if="tranMode === 'query'">
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDate(busClsCvrFrom.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-flex lg6 md12 xs12>
        <v-btn color="error" dark class=" mr-2" @click.prevent="doCancel">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
        <v-btn v-if="tranMode === 'new'" color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
          Save
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export default {
  props: {
    cvrType: String,
    menu: Object,
    tranMode: String,
    busCls: String
  },
  data() {
    return {
      labels: {
        busCls: 'Business Class',
        cvrType: 'Cover Type',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      busClsCvrFrom: {
        busCls: null,
        cvrType: null,
        oriCvrType: null,
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        createdDate: new Date(),
        modifiedName: null,
        modifiedDate: null
      },
      newBusClsCvr: false,
      busClsList: [],
      cvrTypeList: [],
      submitting: false
    }
  },
  watch: {
    busCls: function (value) {
      this.fetchData()
    }
  },
  methods: {
    getDesc(value) {
      for (var i in this.cvrTypeList) {
        if (this.cvrTypeList[i].value === value) {
          return this.cvrTypeList[i].label
        }
      }
    },
    formatDisplayDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    initForm() {
      this.busClsCvrFrom.cvrType = this.cvrType
      this.busClsCvrFrom.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
      this.busClsCvrFrom.createdDate = new Date()
      this.busClsCvrFrom.modifiedName = null
      this.busClsCvrFrom.modifiedDate = null
    },
    async fetchData() {
      this.getBusClsList()
      this.getCoverList()
      if (this.tranMode === 'new') {
        this.initForm()
      } else {
        this.getBusCoverDetail()
      }
    },
    async getBusClsList() {
      const apiURI = this.menu.getBusClsList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.busClsList = []
        if (data) {
          data.map((busCls) => {
            const convertList = {
              label: busCls.busCls + ' - ' + busCls.busClsDesc,
              value: busCls.busCls
            }
            this.busClsList.push(convertList)
          })
        }
      }
    },
    async getCoverList() {
      const apiURI = this.menu.getCoverList
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result.data
        this.cvrTypeList = []
        if (data) {
          data.map((cover) => {
            const convertList = {
              label: cover.label,
              value: cover.value
            }
            this.cvrTypeList.push(convertList)
          })
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.doCreate()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createBusClsCvr
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.busClsCvrFrom)
          const { data } = result
          if (data) {
            this.notify(data)
            this.$emit('close')
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.errorMessage(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getBusCoverDetail() {
      const apiURI = this.menu.getBusClsCvr
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            busCls: this.busCls,
            cvrType: this.cvrType
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.busClsCvrFrom.busCls = data.busClsCvr.busCls
            // this.busClsCvrFrom.cvrType = data.busClsCvr.cvrType
            this.busClsCvrFrom.createdName = data.busClsCvr.createdName
            this.busClsCvrFrom.createdDate = data.busClsCvr.createdDate
            this.busClsCvrFrom.modifiedName = data.busClsCvr.modifiedName
            this.busClsCvrFrom.modifiedDate = data.busClsCvr.modifiedDate
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$emit('close')
    }
  },
  computed: {
    filterBusClsList() {
      return this.busClsList.filter((list) => {
        return list.value === this.busClsCvrFrom.busCls
      })
    }
  },
  mounted() {
    this.fetchData()
  },
  mixins: [MessageMixin]
}
</script>
